import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, diasParaVencer } from '../../contexts/AuthContext';
import { useData } from '../../contexts/DataContext';
import { supabase } from '../../lib/supabase';
import AdminLayout from '../../components/AdminLayout';
import AvatarUpload from '../../components/AvatarUpload';

const PLANOS = ['mensal','trimestral','semestral'];

const CAMPOS_EVOLUCAO = [
  { key: 'peso',    label: 'Peso',    unidade: 'kg' },
  { key: 'gordura', label: 'Gordura', unidade: '%'  },
  { key: 'cintura', label: 'Cintura', unidade: 'cm' },
  { key: 'abdomen', label: 'Abdômen', unidade: 'cm' },
  { key: 'quadril', label: 'Quadril', unidade: 'cm' },
  { key: 'braco',   label: 'Braço',   unidade: 'cm' },
  { key: 'coxa',    label: 'Coxa',    unidade: 'cm' },
];

const s = {
  header: { marginBottom: '32px' },
  title: { fontFamily: "'Inter', sans-serif", fontSize: '34px', fontWeight: 700, color: 'var(--text)', marginBottom: '6px' },
  titleSpan: { fontStyle: 'italic', color: '#5B402E' },
  sub: { fontSize: '14px', color: '#8C7F70' },
  topRow: { display: 'flex', gap: '12px', alignItems: 'center', marginBottom: '24px' },
  searchWrap: { position: 'relative', flex: 1 },
  searchIcon: { position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', fontSize: '15px', color: '#8C7F70', pointerEvents: 'none' },
  searchInput: { width: '100%', padding: '12px 14px 12px 42px', border: '1.5px solid var(--divider)', borderRadius: 'var(--r-input)', fontSize: '14px', color: 'var(--text)', background: 'var(--surface)', outline: 'none', boxSizing: 'border-box' },
  addBtn: { padding: '12px 22px', background: 'var(--text)', color: '#FAF7F2', border: 'none', borderRadius: 'var(--r-btn)', fontSize: '13px', fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', cursor: 'pointer', whiteSpace: 'nowrap' },
  filterRow: { display: 'flex', gap: '6px', marginBottom: '20px' },
  filterBtn: { padding: '6px 14px', border: '1px solid var(--divider)', borderRadius: 'var(--r-btn)', background: 'transparent', fontSize: '12px', color: 'var(--text-2)', cursor: 'pointer' },
  filterBtnActive: { background: '#251C19', color: '#FAF7F2', borderColor: '#251C19' },
  alunaCard: { background: 'var(--surface)', border: '1px solid var(--divider)', borderRadius: 'var(--r-card)', padding: '20px 24px', marginBottom: '8px', boxShadow: 'var(--sh-card)', transition: 'border-color 0.2s, box-shadow 0.2s', cursor: 'pointer' },
  alunaCardPausada: { opacity: 0.6, borderStyle: 'dashed' },
  cardTop: { display: 'grid', gridTemplateColumns: '44px 1fr auto', gap: '16px', alignItems: 'center' },
  avatar: { width: '44px', height: '44px', borderRadius: '50%', background: '#251C19', border: '1.5px solid #5B402E', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Inter', sans-serif", fontSize: '18px', fontWeight: 700, color: '#FAF7F2', flexShrink: 0 },
  alunaName: { fontSize: '15px', fontWeight: 600, color: '#251C19', marginBottom: '2px', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' },
  alunaEmail: { fontSize: '12px', color: '#8C7F70' },
  alunaTel: { fontSize: '12px', color: '#8C7F70' },
  statsRow: { display: 'flex', gap: '6px', marginTop: '4px', flexWrap: 'wrap' },
  statChip: { fontSize: '11px', color: 'var(--text-2)', background: 'var(--bg)', padding: '2px 8px', borderRadius: '100px' },
  vencChip: { fontSize: '11px', padding: '2px 8px', borderRadius: '100px', fontWeight: 600 },
  actions: { display: 'flex', gap: '6px', flexWrap: 'wrap', justifyContent: 'flex-end' },
  actionBtn: { padding: '7px 13px', border: '1px solid var(--divider)', borderRadius: 'var(--r-btn)', background: 'transparent', fontSize: '12px', color: 'var(--text-3)', cursor: 'pointer', whiteSpace: 'nowrap', fontWeight: 500 },
  actionBtnWpp: { background: '#25D366', color: '#fff', borderColor: '#25D366' },
  actionBtnPause: { background: 'rgba(200,146,42,0.08)', color: '#5B402E', borderColor: 'rgba(200,146,42,0.3)' },
  actionBtnReativar: { background: 'rgba(76,175,80,0.08)', color: '#2E7D32', borderColor: 'rgba(76,175,80,0.3)' },
  actionBtnDelete: { background: 'rgba(229,57,53,0.06)', color: '#E53935', borderColor: 'rgba(229,57,53,0.2)' },
  badge: { display: 'inline-block', padding: '2px 8px', borderRadius: '100px', fontSize: '10px', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase' },
  badgeAtiva: { background: 'rgba(76,175,80,0.1)', color: '#2E7D32' },
  badgePausada: { background: 'rgba(200,146,42,0.12)', color: '#5B402E' },
  empty: { padding: '60px 40px', textAlign: 'center', background: 'var(--surface)', border: '1px solid var(--divider)', borderRadius: 'var(--r-card)', color: 'var(--text-2)', fontSize: '14px', boxShadow: 'var(--sh-card)' },
  modal: { position: 'fixed', inset: 0, background: 'rgba(37,28,25,0.65)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 300, padding: '20px' },
  modalCard: { background: 'var(--bg)', width: '100%', maxWidth: '500px', padding: '36px', borderRadius: 'var(--r-card)', maxHeight: '90vh', overflowY: 'auto' },
  modalTitle: { fontFamily: "'Inter', sans-serif", fontSize: '28px', fontWeight: 700, color: 'var(--text)', marginBottom: '24px' },
  label: { display: 'block', fontSize: '11px', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#3A2E27', marginBottom: '6px' },
  input: { width: '100%', padding: '10px 14px', border: '1.5px solid var(--divider)', borderRadius: 'var(--r-input)', fontSize: '14px', color: 'var(--text)', background: 'var(--surface)', outline: 'none', marginBottom: '16px', boxSizing: 'border-box' },
  select: { width: '100%', padding: '10px 14px', border: '1.5px solid var(--divider)', borderRadius: 'var(--r-input)', fontSize: '14px', color: 'var(--text)', background: 'var(--surface)', outline: 'none', marginBottom: '16px', boxSizing: 'border-box' },
  modalRow: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
  modalActions: { display: 'flex', gap: '10px', marginTop: '8px' },
  modalBtn: { flex: 1, padding: '12px', background: 'var(--accent)', color: 'var(--btn-text)', border: 'none', borderRadius: 'var(--r-btn)', fontSize: '13px', fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', cursor: 'pointer' },
  modalBtnCancel: { flex: 1, padding: '12px', background: 'transparent', border: '1px solid var(--divider)', color: 'var(--text-2)', borderRadius: 'var(--r-btn)', fontSize: '13px', cursor: 'pointer' },
  confirmModal: { background: 'var(--bg)', width: '100%', maxWidth: '380px', padding: '32px', borderRadius: 'var(--r-card)', textAlign: 'center' },
  confirmIcon: { fontSize: '36px', marginBottom: '12px' },
  confirmTitle: { fontSize: '18px', fontWeight: 700, color: '#251C19', marginBottom: '8px' },
  confirmText: { fontSize: '13px', color: '#8C7F70', marginBottom: '24px', lineHeight: 1.6 },
  confirmActions: { display: 'flex', gap: '10px' },
  btnDanger: { flex: 1, padding: '12px', background: '#E53935', color: '#fff', border: 'none', borderRadius: 'var(--r-btn)', fontSize: '13px', fontWeight: 600, cursor: 'pointer' },
  btnNeutral: { flex: 1, padding: '12px', background: 'transparent', border: '1px solid var(--divider)', color: 'var(--text-2)', borderRadius: 'var(--r-btn)', fontSize: '13px', cursor: 'pointer' },
  renovRow: { background: 'rgba(200,146,42,0.05)', border: '1px solid rgba(200,146,42,0.15)', borderRadius: 'var(--r-btn)', padding: '12px 16px', marginBottom: '20px' },
  renovTitle: { fontSize: '11px', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#5B402E', marginBottom: '8px' },
};

// ─── Mini sparkline SVG ───────────────────────────────────────────────────────
function Sparkline({ valores, cor = '#5B402E' }) {
  if (!valores || valores.length < 2) return null;
  const W = 80, H = 28;
  const min = Math.min(...valores);
  const max = Math.max(...valores);
  const range = max - min || 1;
  const pts = valores.map((v, i) => {
    const x = (i / (valores.length - 1)) * W;
    const y = H - ((v - min) / range) * (H - 4) - 2;
    return `${x},${y}`;
  });
  return (
    <svg width={W} height={H} style={{ display: 'block' }}>
      <polyline points={pts.join(' ')} fill="none" stroke={cor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={pts[pts.length-1].split(',')[0]} cy={pts[pts.length-1].split(',')[1]} r="3" fill={cor} />
    </svg>
  );
}

// ─── Modal perfil da aluna ────────────────────────────────────────────────────
function ModalPerfil({ aluna, onClose, onSalvar }) {
  const [aba, setAba] = useState('contrato');
  const [form, setForm] = useState({
    name: aluna.name || '',
    email: aluna.email || '',
    telefone: aluna.telefone || '',
    plano: aluna.plano || 'mensal',
    inicioPlano: aluna.inicioPlano || new Date().toISOString().split('T')[0],
    acessoTreino: aluna.acessoTreino !== false,
    acessoDieta: aluna.acessoDieta !== false,
    genero: aluna.genero || 'aluna',
  });
  const [evolucao, setEvolucao] = useState([]);
  const [loadingEv, setLoadingEv] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [salvoOk, setSalvoOk] = useState(false);
  const [erroSalvar, setErroSalvar] = useState('');

  useEffect(() => {
    if (aba === 'evolucao') {
      setLoadingEv(true);
      supabase
        .from('evolucao_fisica')
        .select('*')
        .eq('aluna_id', aluna.id)
        .order('data', { ascending: true })
        .then(({ data }) => {
          setEvolucao(data || []);
          setLoadingEv(false);
        });
    }
  }, [aba, aluna.id]);

  async function handleSalvarContrato(e) {
    e.preventDefault();
    setSalvando(true);
    setErroSalvar('');
    try {
      await onSalvar(aluna.id, form);
      setSalvoOk(true);
      setTimeout(() => setSalvoOk(false), 2000);
    } catch (err) {
      setErroSalvar(err.message || 'Não foi possível salvar as alterações.');
    }
    setSalvando(false);
  }

  const formatData = (str) => {
    if (!str) return '—';
    const d = new Date(str + 'T12:00:00');
    return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const ultimoReg = evolucao.length > 0 ? evolucao[evolucao.length - 1] : null;
  const pesos = evolucao.map(r => r.peso).filter(v => v != null).map(Number);

  return (
    <div className="aluna-modal-overlay" style={s.modal} onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="aluna-modal-card" style={{ ...s.modalCard, maxWidth: '600px' }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
          <AvatarUpload userId={aluna.id} nome={aluna.name} size={52} />
          <div style={{ flex: 1 }}>
            <div style={{ fontFamily: "'Inter', sans-serif", fontSize: '20px', fontWeight: 700, color: '#251C19' }}>
              {aluna.name}
            </div>
            <div style={{ fontSize: '13px', color: '#8C7F70' }}>{aluna.email}</div>
            {aluna.telefone && <div style={{ fontSize: '13px', color: '#8C7F70' }}>{aluna.telefone}</div>}
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#8C7F70', padding: '4px' }}>×</button>
        </div>

        {/* Abas */}
        <div style={{ display: 'flex', borderBottom: '1px solid #E8E0D0', marginBottom: '24px', gap: '0' }}>
          {[['contrato','📋 Contrato'], ['evolucao','📊 Evolução Física']].map(([id, label]) => (
            <button key={id} onClick={() => setAba(id)} style={{
              padding: '10px 18px', border: 'none', background: 'none',
              fontSize: '13px', fontWeight: aba === id ? 700 : 500,
              color: aba === id ? '#5B402E' : '#8C7F70',
              borderBottom: aba === id ? '2px solid #5B402E' : '2px solid transparent',
              cursor: 'pointer', marginBottom: '-1px',
            }}>
              {label}
            </button>
          ))}
        </div>

        {/* Aba contrato */}
        {aba === 'contrato' && (
          <form onSubmit={handleSalvarContrato}>
            <div style={{ marginBottom: '20px' }}>
              <label style={s.label}>Nome completo</label>
              <input style={s.input} value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} required />
              <div className="aluna-modal-row" style={s.modalRow}>
                <div>
                  <label style={s.label}>Email</label>
                  <input style={s.input} type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} required />
                </div>
                <div>
                  <label style={s.label}>WhatsApp</label>
                  <input style={s.input} value={form.telefone} onChange={e => setForm(f => ({ ...f, telefone: e.target.value }))} placeholder="+1 (954) 000-0000" />
                </div>
              </div>
              <div className="aluna-modal-row" style={s.modalRow}>
                <div>
                  <label style={s.label}>Gênero (saudação no app)</label>
                  <select style={s.select} value={form.genero} onChange={e => setForm(f => ({ ...f, genero: e.target.value }))}>
                    <option value="aluna">Aluna</option>
                    <option value="aluno">Aluno</option>
                  </select>
                </div>
              </div>
              <div style={{ fontSize: '11px', color: 'var(--text-2)', marginTop: '-10px' }}>
                Trocar o e-mail também atualiza o login da aluna.
              </div>
            </div>

            <div className="aluna-modal-row" style={s.modalRow}>
              <div>
                <label style={s.label}>Plano</label>
                <select style={s.select} value={form.plano} onChange={e => setForm(f => ({ ...f, plano: e.target.value }))}>
                  {PLANOS.map(p => <option key={p} value={p}>{p.charAt(0).toUpperCase() + p.slice(1)}</option>)}
                </select>
              </div>
              <div>
                <label style={s.label}>Início do contrato</label>
                <input style={s.input} type="date" value={form.inicioPlano} onChange={e => setForm(f => ({ ...f, inicioPlano: e.target.value }))} />
              </div>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={s.label}>Acesso liberado</label>
              <div style={{ display: 'flex', gap: '10px' }}>
                <label style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 14px', border: `1.5px solid ${form.acessoTreino ? 'var(--accent)' : 'var(--divider)'}`, borderRadius: 'var(--r-btn)', background: form.acessoTreino ? 'rgba(137,91,64,0.06)' : 'transparent', fontSize: '13px', color: 'var(--text)', cursor: 'pointer' }}>
                  <input type="checkbox" checked={form.acessoTreino} onChange={e => setForm(f => ({ ...f, acessoTreino: e.target.checked }))} />
                  Treino
                </label>
                <label style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 14px', border: `1.5px solid ${form.acessoDieta ? 'var(--accent)' : 'var(--divider)'}`, borderRadius: 'var(--r-btn)', background: form.acessoDieta ? 'rgba(137,91,64,0.06)' : 'transparent', fontSize: '13px', color: 'var(--text)', cursor: 'pointer' }}>
                  <input type="checkbox" checked={form.acessoDieta} onChange={e => setForm(f => ({ ...f, acessoDieta: e.target.checked }))} />
                  Nutrição
                </label>
              </div>
            </div>

            {/* Resumo */}
            <div style={{ background: 'var(--surface-2)', borderRadius: 'var(--r-btn)', padding: '14px 16px', marginBottom: '20px', fontSize: '13px', color: 'var(--text-3)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                <span>Plano atual:</span>
                <strong style={{ textTransform: 'capitalize' }}>{form.plano}</strong>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                <span>Início:</span>
                <strong>{formatData(form.inicioPlano)}</strong>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Status:</span>
                <strong style={{ color: diasParaVencer(form.inicioPlano, form.plano) < 0 ? '#E53935' : '#2E7D32' }}>
                  {(() => {
                    const d = diasParaVencer(form.inicioPlano, form.plano);
                    if (d === null) return '—';
                    if (d < 0) return `Vencido há ${Math.abs(d)}d`;
                    if (d === 0) return 'Vence hoje';
                    return `${d}d para vencer`;
                  })()}
                </strong>
              </div>
            </div>

            {erroSalvar && (
              <div style={{ padding: '10px 14px', background: 'rgba(229,57,53,0.07)', border: '1px solid rgba(229,57,53,0.2)', color: '#C62828', borderRadius: 'var(--r-btn)', fontSize: '13px', marginBottom: '16px' }}>
                {erroSalvar}
              </div>
            )}

            {salvoOk && (
              <div style={{ padding: '10px 14px', background: 'rgba(76,175,80,0.08)', border: '1px solid rgba(76,175,80,0.3)', color: '#2E7D32', borderRadius: 'var(--r-btn)', fontSize: '13px', marginBottom: '16px' }}>
                ✓ Contrato atualizado!
              </div>
            )}

            <div style={s.modalActions}>
              <button type="button" style={s.modalBtnCancel} onClick={onClose}>Fechar</button>
              <button type="submit" style={s.modalBtn} disabled={salvando}>
                {salvando ? 'Salvando...' : 'Salvar alterações'}
              </button>
            </div>
          </form>
        )}

        {/* Aba evolução */}
        {aba === 'evolucao' && (
          <div>
            {loadingEv ? (
              <div style={{ textAlign: 'center', padding: '40px', color: '#8C7F70' }}>Carregando...</div>
            ) : evolucao.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '40px', color: '#8C7F70', fontSize: '14px' }}>
                <div style={{ fontSize: '32px', marginBottom: '12px' }}>📊</div>
                Nenhuma medida registrada ainda.<br />
                <span style={{ fontSize: '12px' }}>Use a página <strong>Evolução Física</strong> para lançar medidas.</span>
              </div>
            ) : (
              <>
                {/* Último registro + sparkline */}
                {ultimoReg && (
                  <div style={{ background: '#F5F0E8', borderRadius: '20px', padding: '16px', marginBottom: '20px' }}>
                    <div style={{ fontSize: '11px', fontWeight: 600, color: '#8C7F70', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '12px' }}>
                      Última medição — {formatData(ultimoReg.data)}
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(90px, 1fr))', gap: '10px' }}>
                      {CAMPOS_EVOLUCAO.map(c => ultimoReg[c.key] != null && (
                        <div key={c.key} style={{ background: 'var(--surface)', borderRadius: 'var(--r-btn)', padding: '10px', textAlign: 'center' }}>
                          <div style={{ fontSize: '11px', color: '#8C7F70', marginBottom: '2px' }}>{c.label}</div>
                          <div style={{ fontSize: '16px', fontWeight: 700, color: '#251C19', fontFamily: "'Inter', sans-serif" }}>
                            {parseFloat(ultimoReg[c.key]).toFixed(1)}<span style={{ fontSize: '11px', fontWeight: 400 }}>{c.unidade}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                    {pesos.length >= 2 && (
                      <div style={{ marginTop: '12px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <span style={{ fontSize: '12px', color: '#8C7F70' }}>Evolução do peso:</span>
                        <Sparkline valores={pesos} />
                        <span style={{ fontSize: '12px', color: '#5B402E', fontWeight: 600 }}>
                          {pesos[0].toFixed(1)} → {pesos[pesos.length-1].toFixed(1)} kg
                          {' '}({pesos[pesos.length-1] - pesos[0] > 0 ? '+' : ''}{(pesos[pesos.length-1] - pesos[0]).toFixed(1)} kg)
                        </span>
                      </div>
                    )}
                  </div>
                )}

                {/* Histórico compacto */}
                <div style={{ fontSize: '11px', fontWeight: 600, color: '#8C7F70', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '8px' }}>
                  Histórico ({evolucao.length} registros)
                </div>
                <div style={{ maxHeight: '220px', overflowY: 'auto', border: '1px solid var(--divider)', borderRadius: 'var(--r-btn)' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                    <thead>
                      <tr style={{ background: '#FAF7F2', position: 'sticky', top: 0 }}>
                        <th style={{ padding: '8px 10px', textAlign: 'left', color: '#8C7F70', fontWeight: 600 }}>Data</th>
                        {CAMPOS_EVOLUCAO.map(c => (
                          <th key={c.key} style={{ padding: '8px 6px', textAlign: 'center', color: '#8C7F70', fontWeight: 600 }}>{c.label}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {[...evolucao].reverse().map((r, i) => (
                        <tr key={r.id} style={{ background: i % 2 === 0 ? 'white' : '#FDFBF8', borderTop: '1px solid #F0EBE0' }}>
                          <td style={{ padding: '7px 10px', fontWeight: 600, color: '#251C19', whiteSpace: 'nowrap' }}>{formatData(r.data)}</td>
                          {CAMPOS_EVOLUCAO.map(c => (
                            <td key={c.key} style={{ padding: '7px 6px', textAlign: 'center', color: '#4A3728' }}>
                              {r[c.key] != null ? `${parseFloat(r[c.key]).toFixed(1)}` : '—'}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}
            <div style={{ marginTop: '20px' }}>
              <button style={s.modalBtnCancel} onClick={onClose}>Fechar</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ─── Helpers ──────────────────────────────────────────────────────────────────
function wppMsg(aluna, tipo) {
  const tel = (aluna.telefone || '').replace(/\D/g, '');
  const msgs = {
    treino: `Olá ${aluna.name.split(' ')[0]}, seu novo treino já está disponível no app! 💪`,
    dieta: `Olá ${aluna.name.split(' ')[0]}, seu plano alimentar foi atualizado no app! 🥗`,
    renovacao: `Olá ${aluna.name.split(' ')[0]}, seu plano está chegando ao fim! Vamos renovar? 😊`,
    geral: `Olá ${aluna.name.split(' ')[0]}, tudo bem? Passando aqui pelo Team Carol Macedo! 👋`,
  };
  return tel ? `https://wa.me/${tel}?text=${encodeURIComponent(msgs[tipo])}` : null;
}

// ─── Página principal ─────────────────────────────────────────────────────────
export default function Alunas() {
  const { alunas, cadastrarAluna, atualizarAluna, pausarAluna, reativarAluna } = useAuth();
  const { treinos, dietas, checkins } = useData();
  const navigate = useNavigate();
  const [busca, setBusca] = useState('');
  const [filtro, setFiltro] = useState('todas');
  const [ordenar, setOrdenar] = useState('urgencia');
  const [showModal, setShowModal] = useState(false);
  const [confirmacao, setConfirmacao] = useState(null);
  const [perfilAluna, setPerfilAluna] = useState(null);
  const [novaAluna, setNovaAluna] = useState({ name: '', email: '', senha: '', ddi: '+55', telefone: '', genero: 'aluna', plano: 'mensal', inicioPlano: new Date().toISOString().split('T')[0], acessoTreino: true, acessoDieta: true });
  const [salvo, setSalvo] = useState(false);
  const [tourEnviado, setTourEnviado] = useState('');

  const ultimoCheckinPorAluna = checkins.reduce((mapa, item) => {
    const atual = mapa[item.alunaId];
    if (!atual || new Date(item.criadoEm) > new Date(atual)) mapa[item.alunaId] = item.criadoEm;
    return mapa;
  }, {});

  const alunasFiltradas = [...alunas]
    .filter(a => {
      if (filtro === 'todas') return a.status !== 'arquivada';
      if (filtro === 'vencido') {
        const d = diasParaVencer(a.inicioPlano, a.plano);
        return d !== null && d < 0 && a.status === 'ativa';
      }
      if (filtro === 'sem_treino') return !treinos.some(item => item.alunaId === a.id);
      if (filtro === 'inativas') {
        const ultimo = ultimoCheckinPorAluna[a.id];
        return !ultimo || (Date.now() - new Date(ultimo).getTime()) >= 7 * 86400000;
      }
      return a.status === filtro;
    })
    .filter(a =>
      a.name.toLowerCase().includes(busca.toLowerCase()) ||
      a.email.toLowerCase().includes(busca.toLowerCase()) ||
      (a.telefone || '').includes(busca)
    )
    .sort((a, b) => {
      if (ordenar === 'nome') return a.name.localeCompare(b.name, 'pt-BR');
      if (ordenar === 'entrada') return new Date(b.inicioPlano || 0) - new Date(a.inicioPlano || 0);
      if (ordenar === 'atividade') return new Date(ultimoCheckinPorAluna[b.id] || 0) - new Date(ultimoCheckinPorAluna[a.id] || 0);
      const urgencia = item => {
        const dias = diasParaVencer(item.inicioPlano, item.plano);
        const semTreino = !treinos.some(t => t.alunaId === item.id);
        const ultimo = ultimoCheckinPorAluna[item.id];
        const inativa = !ultimo || Date.now() - new Date(ultimo).getTime() >= 7 * 86400000;
        return (dias !== null && dias < 0 ? 20 : dias !== null && dias <= 7 ? 10 : 0) + (semTreino ? 8 : 0) + (inativa ? 6 : 0);
      };
      return urgencia(b) - urgencia(a);
    });

  const vencendoBreve = alunas.filter(a => {
    const dias = diasParaVencer(a.inicioPlano, a.plano);
    return dias !== null && dias <= 14 && dias >= 0 && a.status === 'ativa';
  });

  async function handleCadastrar(e) {
    e.preventDefault();
    const senha = novaAluna.senha || 'team123';
    const telefoneCompleto = novaAluna.telefone ? novaAluna.ddi + ' ' + novaAluna.telefone : '';
    await cadastrarAluna({ ...novaAluna, password: senha, telefone: telefoneCompleto });
    try {
      const { data: { session } } = await supabase.auth.getSession();
      await fetch('/.netlify/functions/enviar-email-boas-vindas', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session.access_token}` },
        body: JSON.stringify({ nome: novaAluna.name, email: novaAluna.email, senha, genero: novaAluna.genero }),
      });
    } catch(err) { console.error('Erro ao enviar email:', err); }
    setNovaAluna({ name: '', email: '', senha: '', ddi: '+55', telefone: '', genero: 'aluna', plano: 'mensal', inicioPlano: new Date().toISOString().split('T')[0], acessoTreino: true, acessoDieta: true });
    setShowModal(false);
    setSalvo(true);
    setTimeout(() => setSalvo(false), 3000);
  }

  function exportarCSV() {
    const headers = ['Nome', 'Email', 'Telefone', 'Status', 'Plano', 'Início do plano', 'Acesso treino', 'Acesso nutrição'];
    const linhas = alunasFiltradas.map(a => [
      a.name, a.email, a.telefone || '', a.status, a.plano,
      a.inicioPlano || '', a.acessoTreino !== false ? 'Sim' : 'Não', a.acessoDieta !== false ? 'Sim' : 'Não',
    ]);
    const escapeCsv = (v) => `"${String(v ?? '').replace(/"/g, '""')}"`;
    const csv = [headers, ...linhas].map(row => row.map(escapeCsv).join(',')).join('\r\n');
    const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `alunas-team-carol-macedo-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  function confirmar(acao, aluna, e) {
    e.stopPropagation();
    setConfirmacao({ acao, aluna });
  }

  function executarConfirmacao() {
    if (!confirmacao) return;
    const { acao, aluna } = confirmacao;
    if (acao === 'excluir') atualizarAluna(aluna.id, { status: 'arquivada' });
    if (acao === 'pausar') pausarAluna(aluna.id);
    if (acao === 'reativar') reativarAluna(aluna.id);
    setConfirmacao(null);
  }

  async function handleSalvarContrato(id, form) {
    await atualizarAluna(id, form);
  }

  async function enviarTour(aluna, e) {
    e.stopPropagation();
    const { error } = await supabase.from('tour_requests').upsert({ aluna_id: aluna.id, solicitado_em: new Date().toISOString(), concluido_em: null });
    if (error) {
      console.error('Erro ao enviar tour:', error);
      setTourEnviado('Não foi possível enviar a tour. Verifique se a atualização do banco foi aplicada.');
    } else {
      setTourEnviado(`Tour enviada para ${aluna.name}. Ela verá no próximo acesso.`);
    }
    setTimeout(() => setTourEnviado(''), 5000);
  }

  function getStats(id) {
    return {
      t: treinos.filter(x => x.alunaId === id).length,
      d: dietas.filter(x => x.alunaId === id).length,
      c: checkins.filter(x => x.alunaId === id).length,
    };
  }

  function vencChipStyle(dias) {
    if (dias === null) return null;
    if (dias < 0) return { ...s.vencChip, background: 'rgba(229,57,53,0.1)', color: '#E53935' };
    if (dias <= 7) return { ...s.vencChip, background: 'rgba(229,57,53,0.1)', color: '#E53935' };
    if (dias <= 14) return { ...s.vencChip, background: 'rgba(200,146,42,0.1)', color: '#5B402E' };
    return { ...s.vencChip, background: 'rgba(76,175,80,0.1)', color: '#2E7D32' };
  }

  function vencLabel(dias) {
    if (dias === null) return null;
    if (dias < 0) return `Vencido há ${Math.abs(dias)}d`;
    if (dias === 0) return 'Vence hoje';
    return `${dias}d para vencer`;
  }

  return (
    <AdminLayout>
      <style>{`
        .alunas-page { min-width: 0; overflow: hidden; }
        .alunas-top-row, .alunas-filters { scrollbar-width: none; }
        .alunas-top-row::-webkit-scrollbar, .alunas-filters::-webkit-scrollbar { display: none; }
        @media (max-width: 767px) {
          .alunas-page-title { font-size: 28px !important; line-height: 1.08; }
          .alunas-page-header { margin-bottom: 24px !important; }
          .alunas-top-row { display: grid !important; grid-template-columns: 1fr 1fr; gap: 10px !important; }
          .alunas-search { grid-column: 1 / -1; min-width: 0; }
          .alunas-top-row > button { width: 100%; min-width: 0; padding: 11px 10px !important; }
          .alunas-filters { overflow-x: auto; margin-right: -16px; padding-right: 16px; padding-bottom: 4px; }
          .alunas-filters > button { flex: 0 0 auto; }
          .aluna-card { padding: 18px !important; border-radius: 24px !important; }
          .aluna-card-top { display: grid !important; grid-template-columns: 44px minmax(0, 1fr) !important; gap: 12px !important; align-items: start !important; }
          .aluna-card-info { min-width: 0; }
          .aluna-card-email, .aluna-card-tel { overflow-wrap: anywhere; }
          .aluna-card-actions { grid-column: 1 / -1; display: grid !important; grid-template-columns: 1fr 1fr; gap: 8px !important; width: 100%; margin-top: 6px; }
          .aluna-card-actions > button, .aluna-card-actions > a { width: 100%; min-width: 0; min-height: 42px; justify-content: center !important; white-space: normal !important; line-height: 1.2; padding: 8px 7px !important; }
          .aluna-modal-overlay { padding: 10px !important; align-items: flex-end !important; }
          .aluna-modal-card { max-height: calc(100dvh - 20px) !important; padding: 24px 18px !important; border-radius: 26px 26px 18px 18px !important; }
          .aluna-modal-row { grid-template-columns: 1fr !important; gap: 0 !important; }
          .aluna-modal-title { font-size: 24px !important; margin-bottom: 20px !important; }
        }
        @media (max-width: 390px) {
          .aluna-card-actions { grid-template-columns: 1fr; }
        }
      `}</style>
      <div className="alunas-page">
      <div className="alunas-page-header" style={s.header}>
        <h1 className="alunas-page-title" style={s.title}>Alunas <span style={s.titleSpan}>& Clientes</span></h1>
        <p style={s.sub}>Gerencie acessos, planos e ações por aluna.</p>
      </div>

      {vencendoBreve.length > 0 && (
        <div style={s.renovRow}>
          <div style={s.renovTitle}>⚠ Renovações nos próximos 14 dias</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {vencendoBreve.map(a => {
              const dias = diasParaVencer(a.inicioPlano, a.plano);
              const wpp = wppMsg(a, 'renovacao');
              return (
                <div key={a.id} style={{ fontSize: '13px', color: '#251C19', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <strong>{a.name.split(' ')[0]}</strong>
                  <span style={vencChipStyle(dias)}>{vencLabel(dias)}</span>
                  {wpp && <a href={wpp} target="_blank" rel="noreferrer" style={{ fontSize: '11px', color: '#25D366', fontWeight: 600 }}>Avisar no WhatsApp</a>}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {salvo && <div style={{ padding: '12px 16px', background: 'rgba(76,175,80,0.08)', border: '1px solid rgba(76,175,80,0.3)', color: '#2E7D32', borderRadius: 'var(--r-btn)', fontSize: '13px', marginBottom: '16px' }}>✓ Aluna cadastrada!</div>}
      {tourEnviado && <div style={{ padding: '12px 16px', background: 'rgba(62,110,147,0.08)', border: '1px solid rgba(62,110,147,0.25)', color: '#3E6E93', borderRadius: 'var(--r-btn)', fontSize: '13px', marginBottom: '16px' }}>{tourEnviado}</div>}

      <div className="alunas-top-row" style={s.topRow}>
        <div className="alunas-search" style={s.searchWrap}>
          <span style={s.searchIcon}>🔍</span>
          <input style={s.searchInput} placeholder="Buscar por nome, email ou telefone..." value={busca} onChange={e => setBusca(e.target.value)} />
        </div>
        <select aria-label="Ordenar alunas" value={ordenar} onChange={e => setOrdenar(e.target.value)} style={{ ...s.select, width:'auto', minWidth:'170px', margin:0 }}>
          <option value="urgencia">Mais urgentes</option>
          <option value="atividade">Atividade recente</option>
          <option value="entrada">Entrada mais recente</option>
          <option value="nome">Nome A–Z</option>
        </select>
        <button style={s.actionBtn} onClick={exportarCSV}>⬇ Exportar CSV</button>
        <button style={s.addBtn} onClick={() => setShowModal(true)}>+ Nova aluna</button>
      </div>

      <div className="alunas-filters" style={s.filterRow}>
        {[['todas','Todas'], ['ativa','Ativas'], ['pausada','Pausadas'], ['vencido','Vencidos'], ['sem_treino','Sem treino'], ['inativas','Sem atividade 7d'], ['arquivada','Arquivadas']].map(([v,l]) => {
          const count = v === 'todas' ? null : v === 'vencido'
            ? alunas.filter(a => { const d = diasParaVencer(a.inicioPlano, a.plano); return d !== null && d < 0 && a.status === 'ativa'; }).length
            : v === 'sem_treino' ? alunas.filter(a => !treinos.some(item => item.alunaId === a.id)).length
            : v === 'inativas' ? alunas.filter(a => { const ultimo = ultimoCheckinPorAluna[a.id]; return !ultimo || Date.now() - new Date(ultimo).getTime() >= 7 * 86400000; }).length
            : alunas.filter(a => a.status === v).length;
          return (
            <button key={v} style={{ ...s.filterBtn, ...(filtro === v ? s.filterBtnActive : {}), ...(v === 'vencido' && count > 0 ? { borderColor:'rgba(229,57,53,0.4)', color: filtro === v ? '#FAF7F2' : '#E53935', background: filtro === v ? '#E53935' : 'rgba(229,57,53,0.06)' } : {}) }} onClick={() => setFiltro(v)}>
              {l} {count !== null && `(${count})`}
            </button>
          );
        })}
      </div>

      {alunasFiltradas.length === 0 ? (
        <div style={s.empty}>{busca ? `Nenhuma aluna encontrada para "${busca}"` : 'Nenhuma aluna nessa categoria.'}</div>
      ) : alunasFiltradas.map(aluna => {
        const stats = getStats(aluna.id);
        const dias = diasParaVencer(aluna.inicioPlano, aluna.plano);
        const wpp = wppMsg(aluna, 'geral');
        return (
          <div
            key={aluna.id}
            className="aluna-card"
            style={{ ...s.alunaCard, ...(aluna.status === 'pausada' ? s.alunaCardPausada : {}) }}
            onClick={() => navigate(`/admin/alunas/${aluna.id}`)}
            onMouseEnter={e => { e.currentTarget.style.borderColor = '#5B402E'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(137,91,64,0.1)'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(37,28,25,0.08)'; e.currentTarget.style.boxShadow = 'none'; }}
          >
            <div className="aluna-card-top" style={s.cardTop}>
              <div onClick={e => e.stopPropagation()}>
                <AvatarUpload userId={aluna.id} nome={aluna.name} size={44} />
              </div>
              <div className="aluna-card-info">
                <div style={s.alunaName}>
                  {aluna.name}
                  <span style={{ ...s.badge, ...(aluna.status === 'ativa' ? s.badgeAtiva : s.badgePausada) }}>{aluna.status}</span>
                  {dias !== null && <span style={vencChipStyle(dias)}>{vencLabel(dias)}</span>}
                </div>
                <div className="aluna-card-email" style={s.alunaEmail}>{aluna.email}</div>
                {aluna.telefone && <div className="aluna-card-tel" style={s.alunaTel}>{aluna.telefone}</div>}
                <div style={s.statsRow}>
                  <span style={s.statChip}>{aluna.plano || 'sem plano'}</span>
                  <span style={s.statChip}>{stats.t} treino{stats.t !== 1 ? 's' : ''}</span>
                  <span style={s.statChip}>{stats.d} plano{stats.d !== 1 ? 's' : ''} alimentar{stats.d !== 1 ? 'es' : ''}</span>
                  <span style={s.statChip}>{stats.c} check-in{stats.c !== 1 ? 's' : ''}</span>
                </div>
              </div>
              <div className="aluna-card-actions" style={s.actions} onClick={e => e.stopPropagation()}>
                <button style={s.actionBtn} onClick={e => { e.stopPropagation(); setPerfilAluna(aluna); }}>✏️ Editar</button>
                <button style={{ ...s.actionBtn, background:'#6B4FA8', color:'#fff', borderColor:'#6B4FA8' }} onClick={e => { e.stopPropagation(); navigate(`/admin/preview/aluna/${aluna.id}`); }}>👁 Visão da aluna</button>
                <button style={s.actionBtn} onClick={e => { e.stopPropagation(); navigate(`/admin/treinos?aluna=${aluna.id}`); }}>🏋️ Treinos</button>
                <button style={s.actionBtn} onClick={e => { e.stopPropagation(); navigate(`/admin/dieta/nova?aluna=${aluna.id}`); }}>🥗 Nutrição</button>
                <button style={s.actionBtn} onClick={e => { e.stopPropagation(); navigate(`/admin/anamnese?aluna=${aluna.id}`); }}>📋 Prontuário</button>
                <button style={s.actionBtn} onClick={e => { e.stopPropagation(); navigate(`/admin/exame/novo?aluna=${aluna.id}`); }}>🧪 Exames</button>
                <button style={s.actionBtn} onClick={e => { e.stopPropagation(); navigate(`/admin/evolucao?aluna=${aluna.id}`); }}>📈 Avaliações e progresso</button>
                <button style={s.actionBtn} onClick={e => { e.stopPropagation(); navigate(`/admin/checkins?aluna=${aluna.id}`); }}>📊 Check-ins</button>
                <button style={s.actionBtn} onClick={e => enviarTour(aluna, e)}>✨ Enviar tour</button>
                {wpp && <a href={wpp} target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()} style={{ ...s.actionBtn, ...s.actionBtnWpp, textDecoration: 'none', display: 'inline-flex', alignItems: 'center' }}>💬 WhatsApp</a>}
                {aluna.status === 'ativa'
                  ? <button style={{ ...s.actionBtn, ...s.actionBtnPause }} onClick={e => confirmar('pausar', aluna, e)}>⏸ Pausar</button>
                  : <button style={{ ...s.actionBtn, ...s.actionBtnReativar }} onClick={e => confirmar('reativar', aluna, e)}>▶ Reativar</button>
                }
                <button style={{ ...s.actionBtn, ...s.actionBtnDelete }} onClick={e => confirmar('excluir', aluna, e)}>📦 Arquivar</button>
              </div>
            </div>
          </div>
        );
      })}

      {/* Modal nova aluna */}
      {showModal && (
        <div className="aluna-modal-overlay" style={s.modal} onClick={e => e.target === e.currentTarget && setShowModal(false)}>
          <div className="aluna-modal-card" style={s.modalCard}>
            <div className="aluna-modal-title" style={s.modalTitle}>Nova aluna</div>
            <form onSubmit={handleCadastrar}>
              <label style={s.label}>Nome completo</label>
              <input style={s.input} value={novaAluna.name} onChange={e => setNovaAluna(n => ({ ...n, name: e.target.value }))} placeholder="Nome da aluna" required />
              <label style={s.label}>Email</label>
              <input style={s.input} type="email" value={novaAluna.email} onChange={e => setNovaAluna(n => ({ ...n, email: e.target.value }))} placeholder="email@exemplo.com" required />
              <label style={s.label}>Senha inicial</label>
              <input style={s.input} type="text" value={novaAluna.senha||''} onChange={e => setNovaAluna(n => ({ ...n, senha: e.target.value }))} placeholder="Deixe em branco para usar team123" />
              <div style={{ fontSize: '11px', color: 'var(--text-2)', marginTop: '-10px', marginBottom: '16px' }}>
                Se não preencher, a senha inicial da nova aluna será <strong>team123</strong>.
              </div>
              <label style={s.label}>WhatsApp</label>
              <div style={{ display:'flex', gap:'8px', marginBottom:'10px' }}>
                <select style={{ ...s.select, width:'90px', flexShrink:0, margin:0 }} value={novaAluna.ddi === '+55' || novaAluna.ddi === '+1' ? novaAluna.ddi : 'outro'} onChange={e => setNovaAluna(n => ({ ...n, ddi: e.target.value === 'outro' ? '' : e.target.value }))}>
                  <option value="+55">🇧🇷 +55</option>
                  <option value="+1">🇺🇸 +1</option>
                  <option value="outro">Outro</option>
                </select>
                {(novaAluna.ddi !== '+55' && novaAluna.ddi !== '+1') && (
                  <input style={{ ...s.input, width:'72px', flexShrink:0, margin:0 }} value={novaAluna.ddi} onChange={e => setNovaAluna(n => ({ ...n, ddi: e.target.value }))} placeholder="+XX" />
                )}
                <input style={{ ...s.input, flex:1, margin:0 }} value={novaAluna.telefone} onChange={e => setNovaAluna(n => ({ ...n, telefone: e.target.value }))} placeholder="(11) 99999-9999" />
              </div>
              <select style={s.select} value={novaAluna.genero} onChange={e => setNovaAluna(n => ({ ...n, genero: e.target.value }))}>
                <option value="aluna">Aluna</option>
                <option value="aluno">Aluno</option>
              </select>
              <div className="aluna-modal-row" style={s.modalRow}>
                <div>
                  <label style={s.label}>Plano</label>
                  <select style={s.select} value={novaAluna.plano} onChange={e => setNovaAluna(n => ({ ...n, plano: e.target.value }))}>
                    {PLANOS.map(p => <option key={p} value={p}>{p.charAt(0).toUpperCase() + p.slice(1)}</option>)}
                  </select>
                </div>
                <div>
                  <label style={s.label}>Início do plano</label>
                  <input style={s.input} type="date" value={novaAluna.inicioPlano} onChange={e => setNovaAluna(n => ({ ...n, inicioPlano: e.target.value }))} />
                </div>
              </div>
              <label style={s.label}>Acesso liberado</label>
              <div style={{ display: 'flex', gap: '10px', marginBottom: '16px' }}>
                <label style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 14px', border: `1.5px solid ${novaAluna.acessoTreino !== false ? 'var(--accent)' : 'var(--divider)'}`, borderRadius: 'var(--r-btn)', background: novaAluna.acessoTreino !== false ? 'rgba(137,91,64,0.06)' : 'transparent', fontSize: '13px', color: 'var(--text)', cursor: 'pointer' }}>
                  <input type="checkbox" checked={novaAluna.acessoTreino !== false} onChange={e => setNovaAluna(n => ({ ...n, acessoTreino: e.target.checked }))} />
                  Treino
                </label>
                <label style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 14px', border: `1.5px solid ${novaAluna.acessoDieta !== false ? 'var(--accent)' : 'var(--divider)'}`, borderRadius: 'var(--r-btn)', background: novaAluna.acessoDieta !== false ? 'rgba(137,91,64,0.06)' : 'transparent', fontSize: '13px', color: 'var(--text)', cursor: 'pointer' }}>
                  <input type="checkbox" checked={novaAluna.acessoDieta !== false} onChange={e => setNovaAluna(n => ({ ...n, acessoDieta: e.target.checked }))} />
                  Nutrição
                </label>
              </div>
              <div style={s.modalActions}>
                <button type="button" style={s.modalBtnCancel} onClick={() => setShowModal(false)}>Cancelar</button>
                <button type="submit" style={s.modalBtn}>Cadastrar</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal perfil */}
      {perfilAluna && (
        <ModalPerfil
          aluna={perfilAluna}
          onClose={() => setPerfilAluna(null)}
          onSalvar={handleSalvarContrato}
        />
      )}

      {/* Modal confirmação */}
      {confirmacao && (
        <div style={s.modal}>
          <div style={s.confirmModal}>
            <div style={s.confirmIcon}>{confirmacao.acao === 'excluir' ? '🗑️' : confirmacao.acao === 'pausar' ? '⏸️' : '▶️'}</div>
            <div style={s.confirmTitle}>
              {confirmacao.acao === 'excluir' ? 'Arquivar aluna?' : confirmacao.acao === 'pausar' ? 'Pausar acesso?' : 'Reativar acesso?'}
            </div>
            <div style={s.confirmText}>
              {confirmacao.acao === 'excluir' && `${confirmacao.aluna.name} sairá das listas ativas, mas os dados serão preservados e poderão ser recuperados.`}
              {confirmacao.acao === 'pausar' && `${confirmacao.aluna.name} não conseguirá fazer login até ser reativada. Os dados ficam salvos.`}
              {confirmacao.acao === 'reativar' && `${confirmacao.aluna.name} voltará a ter acesso ao app normalmente.`}
            </div>
            <div style={s.confirmActions}>
              <button style={s.btnNeutral} onClick={() => setConfirmacao(null)}>Cancelar</button>
              <button style={confirmacao.acao === 'reativar' ? { ...s.btnDanger, background: '#2E7D32' } : s.btnDanger} onClick={executarConfirmacao}>
                {confirmacao.acao === 'excluir' ? 'Arquivar' : confirmacao.acao === 'pausar' ? 'Pausar' : 'Reativar'}
              </button>
            </div>
          </div>
        </div>
      )}
      </div>
    </AdminLayout>
  );
}
